<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <proveedor-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ProveedorShowData from "./ProveedorShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ProveedorShow",
        components: {CrudShow, ProveedorShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'proveedor.showing',
            }
        },
    }
</script>
